export enum HourBookingCategory {
    Normal = 0,
    PeriodOvertime50 = 1,
    PeriodOvertime100 = 2,
    WeekOvertime50 = 3,
    WeekOvertime100 = 4,
    Evening = 5,
    Night = 6,
    Saturday = 7,
    SundayOrHoliday = 8,
    PaidBreak = 10,
    CustomNormalType = 11,
    GrandHoliday = 13,
    HalfDailyAllowance = 21,
    DailyAllowance = 22,
    DailyOvertime50 = 33,
    DailyOvertime100 = 34,
    MonthlyOvertime50 = 35,
    OvertimeBase = 50,
    Break = 100,
    PaidWaiting = 101,
    UnPaidWaiting = 102,
    CustomAnyType = 110,
    CustomAddition = 111,
    FixedAddition = 120,
    MealBreak = 1001,
    DayBookingNormal = 2001,
    FillingHour = 3001,
}

export interface IWorkHoursItem {
    workShiftId?: string;
    employeeId: string;
    workOrderId: string;
    costCenterId: string;
    vehicleId?: string;
    category: string;
    categoryId: string; // salaryRowTypeId or category
    salaryRowTypeId: string;
    salaryRowTypeName?: string;
    dateStr: string;
    amount: number;
    comment?: string;
}

export const paidHourBookingCategories = () =>
    [
        HourBookingCategory.Normal,
        HourBookingCategory.CustomNormalType,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.DayBookingNormal,
        HourBookingCategory.OvertimeBase,
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

export const deductionHourBookingCategories = () =>
    [
        HourBookingCategory.Break,
        HourBookingCategory.UnPaidWaiting,
        HourBookingCategory.MealBreak,
    ].map((c) => c.toString());

export const dailyAllowanceCategories = () =>
    [
        HourBookingCategory.HalfDailyAllowance,
        HourBookingCategory.DailyAllowance,
    ].map((c) => c.toString());

export const fillingHourCategories = () =>
    [
        HourBookingCategory.FillingHour,
    ].map((c) => c.toString());

/*
 * Worklog grouping
 */
// Normal paid work
export const normalWorkPaidCategories = () =>
    [
        HourBookingCategory.Normal,
        HourBookingCategory.CustomNormalType,
        HourBookingCategory.PaidBreak,
        HourBookingCategory.PaidWaiting,
        HourBookingCategory.OvertimeBase,
    ].map((c) => c.toString());

// Additions
export const additionCategories = () =>
    [
        HourBookingCategory.Evening,
        HourBookingCategory.Night,
        HourBookingCategory.Saturday,
        HourBookingCategory.SundayOrHoliday,
        HourBookingCategory.GrandHoliday,
        HourBookingCategory.CustomAddition,
        HourBookingCategory.FixedAddition,
    ].map((c) => c.toString());

// Overtime
export const overtimeCategories = () =>
    [
        HourBookingCategory.PeriodOvertime50,
        HourBookingCategory.PeriodOvertime100,
        HourBookingCategory.WeekOvertime50,
        HourBookingCategory.WeekOvertime100,
        HourBookingCategory.DailyOvertime50,
        HourBookingCategory.DailyOvertime100,
        HourBookingCategory.MonthlyOvertime50,
    ].map((c) => c.toString());
